import { Link } from "react-router-dom";
import { CONTACT_EMAIL, DIVISIONS } from "@/data/content";

const COMPANY_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Capabilities", to: "/#capabilities" },
  { label: "Contact", to: "/contact" },
];

const SOLUTION_LINKS = [
  { label: "Government Contracting", to: "/government-contracting" },
  { label: "Business Solutions", to: "/business-solutions" },
];

export const Footer = () => (
  <footer className="noise-overlay bg-navy text-white" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-12 border-b border-white/10 py-16 lg:grid-cols-12 lg:py-20">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="inline-block h-2.5 w-2.5 bg-gold" />
            <span className="font-heading text-lg font-extrabold tracking-tight">
              ICONICHO
              <span className="ml-1.5 font-light text-white/50">LLC</span>
            </span>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
            Enterprise &amp; business solutions — consulting, professional services,
            training, marketing, procurement, supply, logistics, and operational
            support for businesses, organizations, and government partners.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email-link"
            className="mt-6 inline-block border-b border-gold/50 pb-0.5 text-sm font-medium text-white transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-xs font-medium uppercase tracking-[0.25em] text-white/40">
            Company
          </h3>
          <ul className="mt-5 space-y-3">
            {COMPANY_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-gold"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-xs font-medium uppercase tracking-[0.25em] text-white/40">
            Solutions
          </h3>
          <ul className="mt-5 space-y-3">
            {SOLUTION_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-gold"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h3 className="text-xs font-medium uppercase tracking-[0.25em] text-white/40">
            Specialized Offerings
          </h3>
          <ul className="mt-5 space-y-3">
            {DIVISIONS.map((d) => (
              <li key={d.name}>
                <a
                  href={d.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-${d.testId}`}
                  className="text-sm text-white/70 transition-colors duration-300 hover:text-gold"
                >
                  {d.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-start justify-between gap-4 py-8 sm:flex-row sm:items-center">
        <p className="text-xs text-white/40">
          © 2026 Iconicho, LLC. All rights reserved.
        </p>
        <div className="flex items-center gap-6">
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy-link"
            className="text-xs text-white/40 transition-colors duration-300 hover:text-gold"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="text-xs text-white/40 transition-colors duration-300 hover:text-gold"
          >
            Terms &amp; Conditions
          </Link>
        </div>
      </div>
    </div>

    <div className="overflow-hidden px-2 pb-4" aria-hidden="true">
      <p
        className="select-none whitespace-nowrap text-center font-heading text-[13vw] font-extrabold leading-[0.85] tracking-tight text-transparent"
        style={{ WebkitTextStroke: "1px rgba(255,255,255,0.09)" }}
      >
        ICONICHO
      </p>
    </div>
  </footer>
);
